// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1N_25","inputWrap":"CustomTip_inputWrap__3EY71"};